/** A PNG of the canvas. Rejects rather than handing the caller a `null` blob. */
export const canvasToPngBlob = (canvas: HTMLCanvasElement): Promise<Blob> =>
  new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) {
        resolve(blob);
        return;
      }
      // `toBlob` yields null when the canvas is tainted or out of memory. Both
      // are terminal for this export, and both are worth naming in the log.
      reject(new Error("Could not encode the screenshot"));
    }, "image/png");
  });

const pad2 = (value: number) => String(value).padStart(2, "0");

/**
 * `suno-screenshot-2026-09-17-1432.png` — local time, sortable, and distinct
 * enough that two captures a minute apart do not collide in a downloads folder.
 */
export const screenshotFileName = (now: Date = new Date()): string =>
  [
    "suno-screenshot",
    now.getFullYear(),
    pad2(now.getMonth() + 1),
    pad2(now.getDate()),
    `${pad2(now.getHours())}${pad2(now.getMinutes())}`
  ].join("-") + ".png";

/** True when this browser can be asked to put an image on the clipboard. */
export const canCopyImages = (): boolean =>
  typeof ClipboardItem !== "undefined" &&
  typeof navigator !== "undefined" &&
  typeof navigator.clipboard?.write === "function";

export const copyPngToClipboard = async (blob: Blob): Promise<void> => {
  await navigator.clipboard.write([new ClipboardItem({ "image/png": blob })]);
};
